var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7121 3.95806C20.4641 3.7463 20.114 3.70167 19.8206 3.84449L15.3317 6.0298L11.1197 1.17347C10.9639 0.99382 10.7378 0.890625 10.5 0.890625C10.2622 0.890625 10.0361 0.99382 9.8803 1.17347L5.66833 6.02976L1.17941 3.84445C0.886029 3.70167 0.536001 3.74626 0.287857 3.95802C0.0397122 4.16978 -0.0593816 4.50849 0.0354875 4.82062L3.15268 15.0745C3.25772 15.4201 3.57637 15.6562 3.93751 15.6562H17.0625C17.4236 15.6562 17.7423 15.4201 17.8473 15.0746L20.9645 4.82066C21.0594 4.50853 20.9603 4.16982 20.7121 3.95806ZM16.4545 14.0156H4.54548L2.15218 6.14276L5.51636 7.78055C5.8504 7.94314 6.25177 7.86103 6.49512 7.58048L10.5 2.96294L14.5049 7.58048C14.7482 7.86107 15.1497 7.9431 15.4837 7.78055L18.8478 6.14276L16.4545 14.0156Z",
    fill: "#FFB525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4545 14.0156H4.54548L2.15218 6.14276L5.51636 7.78055C5.8504 7.94314 6.25177 7.86103 6.49512 7.58048L10.5 2.96294L14.5049 7.58048C14.7482 7.86107 15.1497 7.9431 15.4837 7.78055L18.8478 6.14276L16.4545 14.0156Z",
    fill: "#FFB525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.009bb06f822f93da49bc3ae1d5395b8e.svg";
export { ForwardRef as ReactComponent };